import { ORGANIZATIONS } from './organizations'
import './LogoBackdrop.css'

// Any image in src/assets/logos named after an organization (e.g. AISC.svg) replaces its wordmark.
const logoFiles = require.context('../../assets/logos', false, /\.(svg|png|jpe?g|webp)$/i)
const LOGOS = Object.fromEntries(
  logoFiles.keys().map((key) => [
    key.replace(/^\.\//, '').replace(/\.[^.]+$/, '').toLowerCase(),
    logoFiles(key),
  ]),
)

const rotate = (list, n) => [...list.slice(n), ...list.slice(0, n)]

// Offset passes keep repeats apart; 120 tiles fill whole rows at 8, 6, and 4 columns, and the
// track renders the set twice so the drift loops seamlessly.
const TILES = [0, 13, 7, 21].flatMap((n) => rotate(ORGANIZATIONS, n))

function Tile({ name }) {
  const src = LOGOS[name.toLowerCase()]
  return (
    <div className="logo-tile">
      {src ? (
        <img className="logo-tile-img" src={src} alt="" draggable="false" />
      ) : (
        <span className={`logo-tile-word${name.length > 6 ? ' is-long' : ''}`}>{name}</span>
      )}
    </div>
  )
}

function LogoBackdrop() {
  return (
    <div className="logo-backdrop" aria-hidden="true">
      <div className="logo-backdrop-track">
        {[0, 1].map((copy) => (
          <div className="logo-backdrop-grid" key={copy}>
            {TILES.map((name, i) => (
              <Tile name={name} key={`${name}-${i}`} />
            ))}
          </div>
        ))}
      </div>
    </div>
  )
}

export default LogoBackdrop
